import TreeNode from "../../../structures/TreeNode";

const node1 = new TreeNode(
  0,
  false,
  -2300,
  0,
  "Debo conseguir dinero para ayudar a mis nietos. No puedo permitir que dejen de estudiar. Seguro puedo sacar un préstamo.",
  0,
  "neutral",
);

node1.quotes = [
  "“Tuve que sacar el préstamo porque a mi hijo no le alcanzaba para la inscripción de mis nietos”",
];

const node1_1 = new TreeNode(
  0,
  false,
  -2300,
  0,
  "Si mi hijo se entera de este préstamo, me va a regañar.",
  0,
);

const node1_2 = new TreeNode(
  0,
  false,
  -2300,
  0,
  "Revisé mis papeles y no encontré nada. Creí que me habían ofrecido algo, pero siento que los pensionados no recibimos ofertas.",
  0,
);

// node1_2.game = 22;

// node1_2.game = 16;

const node1_3 = new TreeNode(
  0,
  false,
  -2300,
  0,
  "Llevo 3 días sin conseguir nada y estoy desesperado.",
  3 * 24,
  "frustrated",
);

const node2_2_0 = new TreeNode(
  2,
  false,
  -3655,
  538,
  "Cliente va al banco. Lo rechazan.",
  0,
  "frustrated",
);

const node2_2 = new TreeNode(
  0,
  false,
  -3655,
  538,
  "El banco no me prestó por ser pensionado y no tener otro ingreso. Veré mis papeles a ver si encuentro algo.",
  0,
);

node2_2.quotes = [
  "“Fue difícil encontrar el teléfono para que me vendieran el préstamo, es como si no quisieran que lo contrates”",
];

const node3_1 = new TreeNode(
  0,
  false,
  -3655,
  538,
  "Llevo 3 días sin éxito y me siento desesperado.",
  3 * 24,
);

const node3_2 = new TreeNode(
  0,
  false,
  -2300,
  0,
  "Iré a la subdelegación, ojalá ahí me puedan orientar.",
  0,
);

const node3_3 = new TreeNode(2, false, -3655, 538, "Acude al IMSS.", 0);

const node3_4 = new TreeNode(
  2,
  false,
  -3655,
  538,
  "Es interceptado por un asesor previsional de Profuturo antes de llegar a la ventanilla del IMSS.",
  0,
);

const node4_1 = new TreeNode(
  1,
  true,
  -3755,
  888,
  "Hola, Sr. Pérez, ¿Tiene un momento?",
  0,
);

node4_1.dialogAnchor = { x: 7 };

const node4_2 = new TreeNode(0, true, -3755, 888, "Sí, claro, dígame.", 0);

const node4_3 = new TreeNode(
  1,
  true,
  -3755,
  888,
  "Mucho gusto, me presento soy Juan de Profuturo. ¿Usted sabe que como pensionado, tiene derecho a un préstamo? ¿Le gustaría más información?",
  0,
);

node4_3.dialogAnchor = { x: 7 };

const node4_4 = new TreeNode(
  0,
  true,
  -3755,
  888,
  "¡Que alivio! Justo estaba en busca de uno. Sí, dígame más, por favor.",
  0,
  "smile",
);

node4_4.quotes = [
  "“Es un alivio que sea tan fácil acceder al préstamo, por eso los escogí por este beneficio que proporcionaban”",
];

const node4_5 = new TreeNode(
  1,
  true,
  -3755,
  888,
  "Perfecto. Para calificar, su pensión debe ser de al menos 3 mil pesos, pagada por el IMSS. También necesita un comprobante de domicilio (máx. 3 meses), una identificación oficial y no tener otro préstamo. ¿Cumple con estos requisitos?",
  0,
);

node4_5.dialogAnchor = { x: 7 };

node4_5.quotes = [
  "“No tenía muchas opciones, ellos me dan un préstamo aunque la tasa sea alta, por eso lo contraté”",
];

const node4_6 = new TreeNode(
  0,
  true,
  -3755,
  888,
  "Sí, cumplo con todo. ¿Cuáles son las condiciones? Quiero entender bien antes de contratar. También me interesa que el depósito sea rápido. ¿Cuánto tarda?",
  0,
);

const node4_7 = new TreeNode(
  1,
  true,
  -3755,
  888,
  "El depósito tarda de 24 a 72 horas. Si gusta, podemos agendar una cita para explicarle los beneficios y condiciones.",
  0,
);

node4_7.dialogAnchor = { x: 7 };

const node4_8 = new TreeNode(
  0,
  true,
  -3755,
  888,
  "Sí, me parece bien. ¿Podría ser mañana a las 5 en la cafetería de Miguel Laurent? Prefiero que no sea en mi casa para que mi hijo no se entere.",
  0,
);

const node4_9 = new TreeNode(1, true, -3755, 888, "Claro, ahí lo veré.", 1);

node4_9.dialogAnchor = { x: 7 };

const node5_1 = new TreeNode(
  2,
  true,
  -3620,
  1295,
  "Pasa un día.",
  24,
  "neutral",
);

const node5_3 = new TreeNode(
  1,
  true,
  -3620,
  1295,
  "Hola, Sr. Pérez, estoy aquí para resolver sus dudas sobre el préstamo.",
  0,
);

node5_3.dialogAnchor = { y: 2 };

const node5_4 = new TreeNode(
  0,
  true,
  -3620,
  1295,
  "Hola, Juan, muchas gracias. Me gustaría saber cómo me cobrarían y cuál es la tasa de interés.",
  0,
);

const node5_5 = new TreeNode(
  1,
  true,
  -3620,
  1295,
  "El pago se descuenta directo de su pensión, así no tiene que preocuparse. La tasa de interés es del 35.10%",
  0,
);

node5_5.dialogAnchor = { y: 2 };

const node5_6 = new TreeNode(
  0,
  true,
  -3620,
  1295,
  "¿35.10%? ¡Es altísima! Pero necesito el dinero...Está bien, lo quiero.",
  0,
  "frustrated",
);

node5_6.quotes = [
  "“Al momento de la venta, no entiendo porque te piden hacer tantas cosas, sólo quiero conratar el préstamo, no entiendo porqué tiene que validar tanto”",
  "“La verdad es que no entendí nada, pedí un préstamo y terminé pagando el triple!! Nunca me dijeron cuánto iba a pagar, siento que me vieron la cara, son muy doblecara”",
];

const node5_7 = new TreeNode(
  1,
  true,
  -3620,
  1295,
  "Perfecto, podemos tramitarlo ahora. Solo necesitamos cierta documentación.",
  0,
  "neutral",
);

node5_7.dialogAnchor = { y: 2 };

const node5_8 = new TreeNode(
  1,
  true,
  -3620,
  1295,
  "Requiero que me comparta su INE, cuenta bancaria y el último talón de pago de su pensión.",
  0,
);
node5_8.dialogAnchor = { y: 2 };

const node5_8_1 = new TreeNode(
  0,
  true,
  -3620,
  1295,
  "De acuerdo, muchas gracias por la información. ¿Qué documentos necesita para iniciar con el proceso?",
  2,
);

const node5_9 = new TreeNode(
  2,
  true,
  -3620,
  1295,
  "Juego 2 (Próximamente)",
  24 * 1,
);

node5_9.game = 25;

const node5_10 = new TreeNode(
  1,
  true,
  -3620,
  1295,
  "Listo ya quedó su solicitud, de 24 horas a 72 horas le depositan el dinero.",
  0,
);

node5_10.dialogAnchor = { y: 2 };

const node6_1 = new TreeNode(
  2,
  false,
  -3720,
  1400,
  "Al día siguiente.",
  24,
  "frustrated",
);

const node6_2 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "El asesor dijo que tardaba de 24 a 72 horas. ¿Cuánto más falta? Quiero sorprender a mi hijo con el dinero para la inscripción.",
  24,
);

const node6_3 = new TreeNode(2, false, -3720, 1400, "Unas horas después.", 3);

const node6_4 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "¡Me llegó el depósito! Qué alivio. Me preocupa el pago final, pero vale la pena por mi familia.",
  0,
  "happy",
);

const node6_5 = new TreeNode(
  2,
  false,
  -3720,
  1400,
  "1 mes después",
  30 * 24,
  "neutral",
);

const node6_6 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "Vendí mi auto y con ese dinero liquidaré mi préstamo.",
  0,
);

const node6_7 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "No sé a donde transferirlo. Llamaré a Profuturo para que me ayuden.",
  0,
);

const node6_8 = new TreeNode(2, false, -3990, 1540, "Llamando", 0);

const node6_9 = new TreeNode(
  1,
  false,
  -3990,
  1540,
  "¡Hola, está llamando a Profuturo! ¿En qué puedo apoyarlo?",
  0,
);

const node6_10 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Hola, quiero ayuda para liquidar mi préstamo. Tengo un dinero extra para pagarlo.",
  0,
);

const node6_11 = new TreeNode(
  1,
  false,
  -3990,
  1540,
  "Con gusto. ¿Tiene su Estado de Cuenta? Se lo enviamos cada mes por correo.",
  0,
);

const node6_12 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Un momento, lo buscaré...",
  0,
);

const node6_13 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Juego Buscar el estado de cuenta",
  0,
);
node6_13.game = 22;

const node6_14 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Listo, aquí lo tengo.",
  0,
);

const node6_15 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Perfecto, en la última página verá su referencia de pago para depositar o transferir. El pago se procesa automáticamente.",
  0,
);

const node6_16 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Muy bien, muchas gracias procederé a realizar la transferencia.",
  0,
);

const node6_17 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "Juego Carrera del Pago",
  0,
);
node6_17.game = 23;

const node6_18 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "Listo, hice la transferencia y liquidé mi préstamo. Ya no deberían descontarme de mi pensión.",
  0,
  "smile",
);

const node6_19 = new TreeNode(2, false, -3720, 1400, "1 mes después", 30 * 24);

const node6_20 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "¡Qué está pasando! ¿Por qué me siguen descontando si ya lo pagué?",
  0,
  "frustrated",
);

const node6_21 = new TreeNode(
  0,
  false,
  -3720,
  1400,
  "Voy a llamar a Profuturo, estoy muy molesto.",
  0,
);

const node6_22 = new TreeNode(2, false, -3990, 1540, "Llamando", 0);

const node6_23 = new TreeNode(
  1,
  false,
  -3990,
  1540,
  "¡Hola, está llamando a Profuturo! ¿En qué puedo apoyarlo?",
  0,
);

const node6_24 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Sí, gracias. ¿Por qué me siguen descontando de mi pensión, si ya terminé de pagar mi préstamo?",
  0,
);

const node6_25 = new TreeNode(
  1,
  false,
  -3990,
  1540,
  "Deme un momento, déjeme corroborar su información.",
  0,
);

const node6_26 = new TreeNode(
  1,
  false,
  -3990,
  1540,
  "Es correcto, aquí tengo registrado en nuestro sistema que usted ya liquidó su préstamo; Sin embargo, la institución es la que debe de hacer el retroactivo. Una disculpa por los inconvenientes causados, estimamos que en un máximo de 90 días hábiles, verá reflejado en su cuenta el retroactivo.",
  0,
  "angry",
);

node6_26.dialogAnchor = { y: 2.5 };

const node6_27 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "¿90 días? Es muchísimo, ¿no hay algo que se pueda hacer para que no sea tanto tiempo de espera?",
  0,
);

const node6_28 = new TreeNode(
  1,
  false,
  -3990,
  1540,
  "Lamento decirle que no, es proceso del IMSS.",
  0,
);

const node6_29 = new TreeNode(
  0,
  false,
  -3990,
  1540,
  "Que terrible esta situación. No me queda más que esperar.",
  0,
);

const node6_30 = new TreeNode(
  2,
  false,
  -4500,
  1990,
  "35 días después",
  35 * 24,
);

const node6_31 = new TreeNode(
  0,
  false,
  -4500,
  1990,
  "¡Al fin, me depositaron lo que me habían descontado! Ya terminé con esta deuda.",
  0,
  "happy",
);

node6_4.quotes = [
  "“La verdad es que estuvo bien que te depositen el dinero rápido, eso quiere decir que sí piensan en nosotros porque obvio saben que lo necesitas”",
  "“Fue un poco engorroso que me hicieran mandar muchas veces mis documentos por un tema con el banco, justo es un tema con el banco, deberían de verlo con ellos, pero bueno, al menos después me depositaron rápido”",
];

const node7 = new TreeNode(2, false, -3990, 1540, "Final", 0);

node7.isLast = true;
node7.ending = 0;

node1.descendants = [
  {
    node: node6_17, //node1_1,
    hint: "Le pediré a alguno de mis nietos que me ayude a investigar",
  },
  {
    node: node1_2,
    hint: "Revisaré mis papeles, seguro alguien me ha ofrecido uno",
  },
];

node1_1.descendants = [
  {
    node: node1_2,
    hint: "Mejor sí buscaré entre mis papeles",
  },
  {
    node: node2_2_0,
    hint: "Me acercaré a un banco",
  },
];

node1_2.descendants = [
  {
    node: node1_3,
    hint: "Continuar",
  },
];

node1_3.descendants = [
  {
    node: node3_2,
    hint: "Continuar",
  },
];

node2_2_0.descendants = [
  {
    node: node2_2,
    hint: "Continuar",
  },
];

node2_2.descendants = [
  {
    node: node3_1,
    hint: "Continuar",
  },
];

node3_1.descendants = [
  {
    node: node3_2,
    hint: "Continuar",
  },
];

node3_2.descendants = [
  {
    node: node3_3,
    hint: "Continuar",
  },
];

node3_3.descendants = [
  {
    node: node3_4,
    hint: "Continuar",
  },
];

node3_4.descendants = [
  {
    node: node4_1,
    hint: "Continuar",
  },
];

node4_1.descendants = [
  {
    node: node4_2,
    hint: "Continuar",
  },
];

node4_2.descendants = [
  {
    node: node4_3,
    hint: "Continuar",
  },
];

node4_3.descendants = [
  {
    node: node4_4,
    hint: "Continuar",
  },
];

node4_4.descendants = [
  {
    node: node4_5,
    hint: "Continuar",
  },
];

node4_5.descendants = [
  {
    node: node4_6,
    hint: "Continuar",
  },
];

node4_6.descendants = [
  {
    node: node4_7,
    hint: "Continuar",
  },
];

node4_7.descendants = [
  {
    node: node4_8,
    hint: "Continuar",
  },
];

node4_8.descendants = [
  {
    node: node4_9,
    hint: "Continuar",
  },
];

node4_9.descendants = [
  {
    node: node5_1,
    hint: "Continuar",
  },
];

node5_1.descendants = [
  {
    node: node5_3,
    hint: "Continuar",
  },
];

node5_3.descendants = [
  {
    node: node5_4,
    hint: "Continuar",
  },
];

node5_4.descendants = [
  {
    node: node5_5,
    hint: "Continuar",
  },
];

node5_5.descendants = [
  {
    node: node5_6,
    hint: "Continuar",
  },
];

node5_6.descendants = [
  {
    node: node5_7,
    hint: "Continuar",
  },
];

node5_7.descendants = [
  {
    node: node5_8,
    hint: "Continuar",
  },
];

node5_8.descendants = [
  {
    node: node5_8_1,
    hint: "Continuar",
  },
];

node5_8_1.descendants = [
  {
    node: node5_9,
    hint: "Continuar",
  },
];

node5_9.descendants = [
  {
    node: node6_1,
    hint: "Continuar",
  },
];

node5_10.descendants = [
  {
    node: node6_1,
    hint: "Continuar",
  },
];

node6_1.descendants = [
  {
    node: node6_2,
    hint: "Continuar",
  },
];

node6_2.descendants = [
  {
    node: node6_3,
    hint: "Continuar",
  },
];

node6_3.descendants = [
  {
    node: node6_4,
    hint: "Continuar",
  },
];

node6_4.descendants = [
  {
    node: node6_5,
    hint: "Continuar",
  },
];

node6_5.descendants = [
  {
    node: node6_6,
    hint: "Continuar",
  },
];

node6_6.descendants = [
  {
    node: node6_7,
    hint: "Continuar",
  },
];
node6_7.descendants = [
  {
    node: node6_8,
    hint: "Continuar",
  },
];
node6_8.descendants = [
  {
    node: node6_9,
    hint: "Continuar",
  },
];
node6_9.descendants = [
  {
    node: node6_10,
    hint: "Continuar",
  },
];
node6_10.descendants = [
  {
    node: node6_11,
    hint: "Continuar",
  },
];
node6_11.descendants = [
  {
    node: node6_12,
    hint: "Continuar",
  },
];
node6_12.descendants = [
  {
    node: node6_13,
    hint: "Continuar",
  },
];
node6_13.descendants = [
  {
    node: node6_14,
    hint: "Continuar",
  },
];
node6_14.descendants = [
  {
    node: node6_15,
    hint: "Continuar",
  },
];
node6_15.descendants = [
  {
    node: node6_16,
    hint: "Continuar",
  },
];
node6_16.descendants = [
  {
    node: node6_17,
    hint: "Continuar",
  },
];
node6_17.descendants = [
  {
    node: node6_18,
    hint: "Continuar",
  },
];
node6_18.descendants = [
  {
    node: node6_19,
    hint: "Continuar",
  },
];
node6_19.descendants = [
  {
    node: node6_20,
    hint: "Continuar",
  },
];
node6_20.descendants = [
  {
    node: node6_21,
    hint: "Continuar",
  },
];
node6_21.descendants = [
  {
    node: node6_22,
    hint: "Continuar",
  },
];
node6_22.descendants = [
  {
    node: node6_23,
    hint: "Continuar",
  },
];

node6_23.descendants = [
  {
    node: node6_24,
    hint: "Continuar",
  },
];
node6_24.descendants = [
  {
    node: node6_25,
    hint: "Continuar",
  },
];
node6_25.descendants = [
  {
    node: node6_26,
    hint: "Continuar",
  },
];
node6_26.descendants = [
  {
    node: node6_27,
    hint: "Continuar",
  },
];
node6_27.descendants = [
  {
    node: node6_28,
    hint: "Continuar",
  },
];
node6_28.descendants = [
  {
    node: node6_29,
    hint: "Continuar",
  },
];
node6_29.descendants = [
  {
    node: node6_30,
    hint: "Continuar",
  },
];
node6_30.descendants = [
  {
    node: node6_31,
    hint: "Continuar",
  },
];
node6_31.descendants = [
  {
    node: node7,
    hint: "Continuar",
  },
];

export default node1;
